import React from "react";

const Footer = () => {
  return (
    <div className="footer footer-bottom" style={{ background: 'transparent !important', borderTop: "1px solid rgba(0,0,0,0.05)", padding: '15px 0' }}>
      <div className="copyright text-center" style={{ color: '#333 !important', fontSize: '14px' }}>
        <p className="mb-0">
          Copyright Wellbeing360 {new Date().getFullYear()} &nbsp; | &nbsp; 
          <span style={{ fontWeight: '600' }}>OTT Admin v1.2</span>
        </p>
      </div>
    </div>
  );
};

export default Footer;
